import React, { createContext, useCallback, useEffect, useState } from 'react';
import useAuth from '../hooks/useAuth';
import { firestore } from './FirebaseContext';
import { isProduction } from '../config';
import { useParams, useLocation } from 'react-router';
import { originServerMock } from '../constants/originServer/originServer';
import DialogUpdateRoutesContext from '../components/_dashboard/olimpo/sandboxProduction/updateRoutes/DialogUpdateRoutesContext';

export const BackendRoutesControlContext = createContext({
  selectNewObjRoute: () => {},
  saveChangesRoutesLocal: () => {},
  saveChangesRoutesDb: () => {},
  backendRoutes: [],
  deployUrls: [],
  localUrls: [],
  workMode: '',
  handleWorkModeStatus: () => {}
});

function BackendRoutesControlProvider({ children }) {
  const [backendRoutes, setBackendRoutes] = useState(null);
  const [localUrls, setLocalUrls] = useState(null);
  const [deployUrls, setDeployUrls] = useState(null);
  const [workMode, setWorkMode] = useState('deploy');

  // estas dos son para almacenar las rutas que se van a cambiar luego
  const [localObjStore, setLocalObjStore] = useState([]);
  const [deployObjStore, setDeployObjStore] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  // const [servicePlatformLocal, setServicePlatformLocal] = useState('');
  // const [servicePlatformDeploy, setServicePlatformDeploy] = useState('');
  // const [serviceMqttLocal, setServiceMqttLocal] = useState('');
  // const [serviceMqttDeploy, setServiceMqttDeploy] = useState('');

  // const handleSetServices = useCallback((item, section, originFront) => {
  //   const urlBackDeploy = [];
  //   const urlBackLocal = [];

  //   if (section === 'service_platform') {
  //     if (originFront === 'local') {
  //       setServicePlatformLocal(item.URL);
  //     }
  //     if (originFront === 'deploy') {
  //       setServicePlatformDeploy(item.URL);
  //     }
  //   }
  //   if (section === 'locker') {
  //     if (originFront === 'local') {
  //       setServiceMqttLocal(item.URL);
  //     }
  //     if (originFront === 'deploy') {
  //       setServiceMqttDeploy(item.URL);
  //     }
  //   }
  // }, []);

  const getUrlsByOriginService = (arrRoutes, origin, section) => {
    if (origin === 'local') {
      const objData = arrRoutes.find((it) => it.localActive && it.section === section);
      return objData;
    }
    if (origin === 'deploy') {
      const objData = arrRoutes.find((it) => it.deployActive && it.section === section);
      return objData;
    }

    return null;
  };

  const compareOriginInfoBySection = (localStorageObj, dbObj) => {
    if (localStorageObj?.id === dbObj?.id && localStorageObj?.URL === dbObj?.URL) {
      return true;
    }
    return false;
  };

  // función para modificar el store de rutas para cambiar
  const selectNewObjRoute = (objItem, origin, section) => {
    let arrStore;
    let handleStore;
    let activeOrigin;

    if (origin === 'local') {
      arrStore = localObjStore;
      handleStore = setLocalObjStore;
      activeOrigin = 'localActive';
    }
    if (origin === 'deploy') {
      arrStore = deployObjStore;
      handleStore = setDeployObjStore;
      activeOrigin = 'deployActive';
    }
    const filterArr = arrStore.filter((it) => it.section !== section);

    handleStore([...filterArr, { ...objItem, [activeOrigin]: true }]);
  };

  // función para guardar cambios en local
  const saveChangesRoutesLocal = () => {
    localStorage.setItem('urlBackLocal', JSON.stringify(localObjStore));
    if (workMode === 'development') {
      window.location.reload(true);
    }
  };

  // función para guardar cambios en DB
  const saveChangesRoutesDb = async () => {
    localStorage.setItem('urlBackDeploy', JSON.stringify(deployObjStore));

    const arr = [];

    const posts = await Promise.all(
      // eslint-disable-next-line consistent-return
      deployObjStore.map(async (obj) => {
        const findedObj = deployUrls.find((it) => it.section === obj.section);

        if (findedObj.id !== obj.id) {
          await firestore.collection('originServersUrl').doc(obj.id).update(obj);
          const res = await firestore
            .collection('originServersUrl')
            .doc(findedObj.id)
            .update({ ...findedObj, deployActive: false });

          return res;
        }
      })
    );

    return posts;
    // window.location.reload(true);
  };

  const handleWorkModeStatus = (value) => {
    localStorage.setItem('workmode', value);
    window.location.reload(true);
  };

  useEffect(() => {
    const workModeReg = localStorage.getItem('workmode');

    if (workModeReg) {
      setWorkMode(workModeReg);
    } else {
      localStorage.setItem('workmode', 'deploy');
      setWorkMode('deploy');
    }
  }, []);

  useEffect(() => {
    // setBackendRoutes(originServerMock);
    async function getData() {
      firestore.collection('originServersUrl').onSnapshot((query) => {
        if (!query.empty) {
          const data = query.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setBackendRoutes(data);
        } else {
          setBackendRoutes(originServerMock);
        }
      });
    }

    getData();
  }, []);

  // para manejar las rutas desde local
  useEffect(() => {
    if (backendRoutes && localUrls) {
      const urlBackLocalStorage = localStorage.getItem('urlBackLocal');
      // const urlBackDeployStorage = localStorage.getItem('urlBackDeploy');

      if (urlBackLocalStorage) {
        const arrData = JSON.parse(urlBackLocalStorage);

        // const servicePlatformData = arrData.find((it) => it.service_platform);
        // const lockerData = arrData.find((it) => it.locker);

        // const servicePLatformDataDb = getUrlsByOriginService(backendRoutes, 'local', 'service_platform');
        // const lockerDataDb = getUrlsByOriginService(backendRoutes, 'local', 'locker');

        // if (
        //   compareOriginInfoBySection(servicePlatformData, servicePLatformDataDb) &&
        //   compareOriginInfoBySection(lockerData, lockerDataDb)
        // ) {
        //   console.log('las rutas locales son iguales');
        // } else {
        //   console.log('las rutas locales no son iguales');
        // }
      } else {
        localStorage.setItem('urlBackLocal', JSON.stringify(localUrls));
        console.log('se agregan las rutas por primera vez');
      }
    }
  }, [backendRoutes, localUrls, workMode]);

  // funcion para actualizar la ruta deploy y actualizar la pagina
  const updateRoutes = () => {
    window.location.reload(true);
  };

  // para manejar las rutas de deploy
  useEffect(() => {
    if (backendRoutes && deployUrls) {
      // const urlBackLocalStorage = localStorage.getItem('urlBackLocal');
      const urlBackDeployStorage = localStorage.getItem('urlBackDeploy');

      if (urlBackDeployStorage) {
        const arrData = JSON.parse(urlBackDeployStorage);

        console.log(arrData);

        const servicePlatformData = arrData?.find((it) => it.section === 'service_platform');
        const lockerData = arrData?.find((it) => it.section === 'locker');

        const servicePLatformDataDb = getUrlsByOriginService(backendRoutes, 'deploy', 'service_platform');
        const lockerDataDb = getUrlsByOriginService(backendRoutes, 'deploy', 'locker');

        console.log({ servicePLatformDataDb, servicePlatformData }, { lockerDataDb, lockerData });

        console.log(
          compareOriginInfoBySection(servicePlatformData, servicePLatformDataDb),
          compareOriginInfoBySection(lockerData, lockerDataDb)
        );

        if (
          compareOriginInfoBySection(servicePlatformData, servicePLatformDataDb) &&
          compareOriginInfoBySection(lockerData, lockerDataDb)
        ) {
          console.log('las rutas de deploy son iguales');
        } else {
          console.log('las rutas de deploy no son iguales');
          localStorage.setItem('urlBackDeploy', JSON.stringify([servicePLatformDataDb, lockerDataDb]));
          if (workMode === 'deploy') {
            setOpenDialog(true);
          }
        }
      } else {
        localStorage.setItem('urlBackDeploy', JSON.stringify(deployUrls));
        if (workMode === 'deploy') {
          setOpenDialog(true);
        }
      }
    }
  }, [backendRoutes, deployUrls, workMode]);

  useEffect(() => {
    if (backendRoutes) {
      const urlBackLocal = [];
      const urlBackDeploy = [];

      const filteredPlatformLocalObj = backendRoutes.filter(
        (item) => item.section === 'service_platform' && item.localActive === true
      );
      // handleSetServices(filteredPlatformLocalObj[0], 'service_platform', 'local');
      const defaultUrl1 = originServerMock.find((it) => it.id === 'BACKEND_PRODUCTION');

      urlBackLocal.push(
        JSON.parse(localStorage.getItem('urlBackLocal'))?.find((it) => it?.section === 'service_platform') ||
          filteredPlatformLocalObj[0] ||
          defaultUrl1
      );

      const filteredPlatformDeployObj = backendRoutes.filter(
        (item) => item.section === 'service_platform' && item.deployActive === true
      );
      // handleSetServices(filteredPlatformDeployObj[0], 'service_platform', 'deploy');
      urlBackDeploy.push(filteredPlatformDeployObj[0] || originServerMock.find((it) => it.id === 'BACKEND_PRODUCTION'));

      const filteredLockerVerLocalObj = backendRoutes.filter(
        (item) => item.section === 'locker' && item.localActive === true
      );
      // handleSetServices(filteredLockerVerLocalObj[0], 'locker', 'local');
      urlBackLocal.push(
        JSON.parse(localStorage.getItem('urlBackLocal'))?.find((it) => it?.section === 'locker') ||
          filteredLockerVerLocalObj[0] ||
          originServerMock.find((it) => it.id === 'LOCKER_V1')
      );

      const filteredLockerVerDeployObj = backendRoutes.filter(
        (item) => item.section === 'locker' && item.deployActive === true
      );
      // handleSetServices(filteredLockerVerDeployObj[0], 'locker', 'deploy');
      urlBackDeploy.push(filteredLockerVerDeployObj[0] || originServerMock.find((it) => it.id === 'LOCKER_V1'));

      setLocalUrls(urlBackLocal);
      setDeployUrls(urlBackDeploy);

      // también seteamos los objetos aquí porque este estado nos servirá como almacén de los nuevos objectos que queremos modificar
      setLocalObjStore(urlBackLocal);
      setDeployObjStore(urlBackDeploy);

      // localStorage.setItem('urlBackLocal', JSON.stringify(urlBackLocal));
      // localStorage.setItem('urlBackDeploy', JSON.stringify(urlBackDeploy));
    }
  }, [backendRoutes]);

  return (
    <BackendRoutesControlContext.Provider
      value={{
        selectNewObjRoute,
        saveChangesRoutesLocal,
        saveChangesRoutesDb,
        backendRoutes,
        localUrls,
        deployUrls,
        handleWorkModeStatus,
        workMode
      }}
    >
      <DialogUpdateRoutesContext open={openDialog} onClose={setOpenDialog} updateRoutes={updateRoutes} />
      {children}
    </BackendRoutesControlContext.Provider>
  );
}

export default BackendRoutesControlProvider;
